import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { usePageMeta } from '../utils/pageMeta';

const TermsOfService: React.FC = () => {
    usePageMeta({
        title: 'Terms of Service | Streven',
        description: 'The terms for using Streven, the Strava activity tools and training plans.',
        path: '/terms-of-service',
    });

    return (
    <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: '100vw', justifyContent: 'space-between' }}>
        <Header />
        <div style={{ maxWidth: '700px', margin: '40px auto', padding: '20px', background: '#fff', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.07)', textAlign: 'left' }}>
            <h1>Terms of Service</h1>
            <p><i>Last updated: 14 October 2026</i></p>
            <p>Welcome to Streven. By using our web application, you agree to the following terms and conditions:</p>
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing or using this service, you agree to be bound by these Terms of Service and our Privacy Policy.</p>
            <h2>2. Use of Service</h2>
            <ul>
                <li>You may use this service only for lawful purposes and in accordance with these terms.</li>
                <li>You must not misuse the service or attempt to access it using unauthorized means.</li>
                <li>We may limit daily use to keep the service running for everyone. Today that is 50 chat messages and 10 training plan builds per day.</li>
            </ul>
            <h2>3. Your Strava Account</h2>
            <ul>
                <li>Streven is not affiliated with or endorsed by Strava. You must follow Strava's terms when you use Streven with your Strava account.</li>
                <li>Streven creates new activities in your Strava account when you ask it to. You are responsible for reviewing them.</li>
            </ul>
            <h2>4. User Data</h2>
            <ul>
                <li>We store the data described in our Privacy Policy to provide the service.</li>
                <li>We share it only with the providers named in the Privacy Policy, and only as needed to provide the service.</li>
            </ul>
            <h2>5. Training Plans and AI</h2>
            <ul>
                <li>Training plans and coach replies are generated by an AI model. They may be wrong or unsuitable for you.</li>
                <li>They are not medical or professional coaching advice. Speak to a doctor or a qualified coach before changing your training, and stop if something hurts.</li>
                <li>You use training plans at your own risk.</li>
            </ul>
            <h2>6. Intellectual Property</h2>
            <ul>
                <li>All content, trademarks, and data on this site are the property of their respective owners.</li>
                <li>You may not copy, modify, or distribute any part of the service without permission.</li>
            </ul>
            <h2>7. Disclaimer</h2>
            <ul>
                <li>This service is provided "as is" without warranties of any kind.</li>
                <li>We are not responsible for any loss or damage resulting from the use of this service.</li>
            </ul>
            <h2>8. Changes to Terms</h2>
            <p>We reserve the right to update these terms at any time. Continued use of the service after changes constitutes acceptance of those changes.</p>
        </div>
        <Footer />
    </div>
    );
};

export default TermsOfService;
